import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import posthog from 'posthog-js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
// import { eventWithTime, blockClass, maskTextClass, hooksParam, PackFn, SamplingStrategy, RecordPlugin, KeepIframeSrcFn } from '@rrweb/types'; 
// import { appConfig } from './app/app.config';
 import { AnalyticsBrowser } from '@segment/analytics-next'

import { AppComponent } from './app/app.component';

const pathParts = window.location.pathname.split('/'); 
const college = pathParts[1]; 

if (college) {
  const savedColor = localStorage.getItem(`primaryColor_${college}`);
  if (savedColor) {
    document.documentElement.style.setProperty('--primary', savedColor);
  }
}
if (environment.production) {
  enableProdMode();
}

// posthog.init('phc_XIf7hpRBHEoHI1lzgp79mkvAk3uCPOnq5Pujt7Cegwb', {
//   api_host:'https://us.i.posthog.com',
//   defaults: '2025-05-24'
// })


//   const analytics = AnalyticsBrowser.load({ writeKey: 'J5CQbn6p9ejiR74pkFczF0CKvtfnqMgU' })

//  // or 

// //  export const analytics = new AnalyticsBrowser()
//  analytics.load({ writeKey: 'J5CQbn6p9ejiR74pkFczF0CKvtfnqMgU' })


// posthog.capture('page_viewed', {
//     page: 'Home Page'
//   });
//   posthog.init('phc_XIf7hpRBHEoHI1lzgp79mkvAk3uCPOnq5Pujt7Cegwb', {
//     opt_out_capturing_by_default: true,
// });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/